import { render, staticRenderFns } from "./StackedChart.vue?vue&type=template&id=f88d1c44&scoped=true&"
import script from "./StackedChart.vue?vue&type=script&lang=ts&"
export * from "./StackedChart.vue?vue&type=script&lang=ts&"
import style0 from "./StackedChart.vue?vue&type=style&index=0&id=f88d1c44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88d1c44",
  null
  
)

export default component.exports